// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TenantRole } from "./TenantRole";
import {
  TenantRoleFromJSON,
  TenantRoleFromJSONTyped,
  TenantRoleToJSON,
  TenantRoleToJSONTyped,
} from "./TenantRole";

/**
 *
 * @export
 * @interface UserCreate
 */
export interface UserCreate {
  /**
   *
   */
  id: string;
  /**
   *
   */
  givenName: string;
  /**
   *
   */
  familyName: string;
  /**
   *
   */
  email: string;
  /**
   *
   */
  role: TenantRole;
  /**
   *
   */
  identityProviderId: string;
  /**
   *
   */
  active?: boolean;
}

/**
 * Check if a given object implements the UserCreate interface.
 */
export function instanceOfUserCreate(value: object): value is UserCreate {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("givenName" in (value as Record<string, any>)) &&
      !("given_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["givenName"] === undefined &&
      (value as Record<string, any>)["given_name"] === undefined)
  )
    return false;
  if (
    (!("familyName" in (value as Record<string, any>)) &&
      !("family_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["familyName"] === undefined &&
      (value as Record<string, any>)["family_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  if (
    (!("identityProviderId" in (value as Record<string, any>)) &&
      !("identity_provider_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identityProviderId"] === undefined &&
      (value as Record<string, any>)["identity_provider_id"] === undefined)
  )
    return false;
  return true;
}

export function UserCreateFromJSON(json: any): UserCreate {
  return UserCreateFromJSONTyped(json, false);
}

export function UserCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreate {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    givenName: json["given_name"],
    familyName: json["family_name"],
    email: json["email"],
    role: TenantRoleFromJSON(json["role"]),
    identityProviderId: json["identity_provider_id"],
    active: json["active"] == null ? undefined : json["active"],
  };
}

export function UserCreateToJSON(json: any): UserCreate {
  return UserCreateToJSONTyped(json, false);
}

export function UserCreateToJSONTyped(
  value?: UserCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    given_name: value["givenName"],
    family_name: value["familyName"],
    email: value["email"],
    role: TenantRoleToJSON(value["role"]),
    identity_provider_id: value["identityProviderId"],
    active: value["active"],
  };
}
